<form [formGroup]="form">
  <!--  <mat-form-field appearance="outline" color="primary">-->
  <!--    <mat-label>{{ 'Name' | translate }}</mat-label>-->
  <!--    <input formControlName="NAME" matInput required="" />-->
  <!--  </mat-form-field>-->
  <mat-form-field appearance="outline" color="primary">
    <mat-label>{{ "Email" | translate }}</mat-label>
    <input formControlName="EMAIL" matInput required="" />
    @if (email?.hasError("required")) {
      <mat-error> Email is required. </mat-error>
    }
    @if (email?.hasError("email")) {
      <mat-error> Please enter a valid email address. </mat-error>
    }
  </mat-form-field>
  <mat-form-field appearance="outline">
    <mat-label>{{ "Select date of birth" | translate }}</mat-label>
    <input formControlName="DATEOFBIRTH" matInput [matDatepicker]="picker" />
    <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker #picker></mat-datepicker>

    @if (dateOfBirth?.hasError("required")) {
      <mat-error> Date of birth is required. </mat-error>
    }
    @if (dateOfBirth?.hasError("underage")) {
      <mat-error> You must be at least 18 years old. </mat-error>
    }
  </mat-form-field>
</form>
